import { render, staticRenderFns } from "./HeaderVideo.vue?vue&type=template&id=5305f85b&scoped=true"
import script from "./HeaderVideo.vue?vue&type=script&lang=js"
export * from "./HeaderVideo.vue?vue&type=script&lang=js"
import style0 from "./HeaderVideo.vue?vue&type=style&index=0&id=5305f85b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5305f85b",
  null
  
)

export default component.exports